import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { blueGreyMui, blueMui, MOBILE_BREAKPOINT } from "@ryde/theme";

export const BulkCreateBookingsFormBlockStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "bulk-create-bookings-form-block",
  },
)<{ $paddingTop?: string }>`
  width: 450px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  .checkbox_container {
    padding-inline-start: 10px;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  padding-top: ${props => (props.$paddingTop ? props.$paddingTop : "auto")};

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    width: 100%;
  }
`;

export const BulkCreateBookingsPassengersBodyStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "bulk-create-bookings-passengers-body",
  },
)`
  display: flex;
  align-items: center;
  gap: 8px;

  span:nth-child(2) {
    font-weight: 600;
    color: ${blueGreyMui._500};
  }
`;

export const BulkCreateBookingsPassengersHeaderStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "bulk-create-bookings-passengers-header",
  },
)`
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 12px;

  span:nth-child(2) {
    color: ${blueMui._500};
  }
`;

export const BulkCreateBookingsRadioCheckboxStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "bulk-create-bookings-radio-checkbox",
  },
)`
  .MuiFormGroup-root {
    padding-inline-start: 30px;
    height: 42px;
    justify-content: center;

    label {
      gap: 8px;
    }
  }
`;

export const BulkCreateBookingsTimeBlockStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "bulk-create-bookings-time-block",
  },
)`
  display: flex;
  justify-content: space-between;
`;

export const BulkBookingHeaderPassengersStyled = styled.header.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "bulk-bookings-header-passengers",
  },
)`
  margin-top: 15px;
`;

export const BulkBookingHeaderStyled = styled.header.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "bulk-bookings-header",
})`
  margin-top: 15px;
`;

export const BulkCreateBookingsCreateFieldsSectionStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "bulk-create-bookings-create-fields-section",
  },
)`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const BulkBookingsUnaffiliatedUnitsAlertStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "bulk-bookings-unaffiliated-units-alert",
  },
)`
  margin-top: 15px;
`;

export const BulkBookingsDirectionScopeNoticeStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "bulk-bookings-direction-scope-notice",
  },
)`
  margin-top: 15px;
`;
